/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */

import React from 'react';
import { Card } from 'react-bootstrap';
import IconButton from 'components/common/IconButton';

const SDIssueActions = ({ issue }) => {

    if (issue == null) {
        return <></>
    }

    const emailAction = (e) => {
        let url = `mailto:${issue.reportedBy.email}?subject=${issue.key}%20${issue.subject}`
        window.open(url);
    }

    const createCCFAction = (e) => {
        let url = `https://alpha15.emplas.co.uk/Internal/CCF/CCF.aspx`
        let query = '?'

        if (issue && issue.customFields && issue.customFields.jobNumber) {
            query += 'ori-job-no=' + issue.customFields.jobNumber + '&'
        }

        if (issue && issue.reportedBy) {
            query += 'email=' + issue.reportedBy.email + '&'
        }
        
        url = url + query

        window.open(url);
    }

    return (
        <Card className='mb-3'>
            <Card.Body className='p-2'>
                <IconButton variant="primary" icon="envelope" className="m-1" transform="shrink-3" onClick={emailAction} size="sm">
                    Send Email
                </IconButton>

                {/* Custom actions */}

                {/* Create CCF */}
                {issue.customActions && issue.customActions.includes('createCCF') ?
                    <IconButton variant="warning" icon="edit" className="m-1" transform="shrink-3" onClick={createCCFAction} size="sm">
                        Create CCF
                    </IconButton> : <></>}

            </Card.Body>
        </Card>);
}

export default SDIssueActions;